import styled from "styled-components";


export const Line = styled.div`
  width: 100%;
  height: ${(props) => (props.color === "orange" ? "3px" : "1px")};
  background-color: ${(props) =>
    props.color === "orange" ? "#FFD4CB" : "#B1B1B1"};
  margin: 1.5rem 0;
`;